import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import './style.css'
import Home from './views/home'
import Rules from './views/rules'
import Admin from './views/admin'
import NotFound from './views/not-found'
import './index.css'
import Subscribe from "./views/subscribe";
import AdminDashboard from './views/admin-dashboard';
import AboutUs from './views/aboutUs';
import Privacy from './views/privacy';

const App = () => {
  return (
    <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>

    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Rules} exact path='/rules' />
        <Route component={Subscribe} exact path='/subscribe' />
        <Route component={Admin} exact path='/admin' />
        <Route component={AdminDashboard} exact path='/admin/dashboard' />
        <Route component={AboutUs} exact path ="/aboutUs"/>
        <Route component={Privacy} exact path ="/privacy" />
        <Route component={NotFound} path="*" />
      </Switch>
    </Router>
    </>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
